module.exports = __webpack_public_path__ + "img/styles3.422d5bf1.png";